import script from "./auth.vue?vue&type=script&lang=ts&setup=true"
export * from "./auth.vue?vue&type=script&lang=ts&setup=true"

import "./auth.vue?vue&type=style&index=0&id=49a3973e&scoped=true&lang=less"

import exportComponent from "/Users/user/Projects/simweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49a3973e"]])

export default __exports__